export default __webpack_public_path__ + "906a6030ac25bc1e1036957bcf593278.svg";